import {wizard} from '@/config/sites'

const navigateToTab = () => {
  window.open(`${wizard.url}/offerte`, '_blank')
}

export default {
  'bindTo': false,
  'method': navigateToTab,
}
